var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"expanding-line",attrs:{"data-aos":"flip-left","data-aos-delay":"0","data-aos-duration":"800","data-aos-easing":"ease-in-quart"}},[_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }